// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "bootstrap"
import "channels"
import 'select2'
import 'select2/dist/js/select2.js'
import "trix/dist/trix.css"
import "trix"

import "@fortawesome/fontawesome-free/js/all";
import "@fortawesome/fontawesome-free/css/all";


var jQuery = require('jquery')
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;

// custom js
require('../packs/custom')


require('datatables.net-bs5')
    // require("datatables-bootstrap")

Rails.start()
Turbolinks.start()
ActiveStorage.start()

require("trix")
require("@rails/actiontext")